export enum PackageCreditItemType {
    Individual = "individual",
    Standard = "standard",
    Family = "family"
}